import { getApiUrl } from "src/common/api/getUrl";
import { dataParser } from "src/common/dataParser";
import { mdmLoader } from "src/common/mdmLoader";
import { rest } from "src/common/rest";
import { ZId, ZRole, zRole, ZRoleSaveData } from "src/types";

export const loadRoles = () => mdmLoader(zRole, getApiUrl(`/core/roles`));

// Получение роли по ID
export const loadRole = async (roleId: string): Promise<ZRole> => {
  const resp = await rest.get(getApiUrl(`/core/roles/${roleId}`));
  const data = dataParser(() => zRole.parse(resp.data), "role response");
  return data;
};

// Обновление роли
export const updateRole = async (
  roleId: ZId,
  roleData: ZRoleSaveData,
): Promise<ZRole> => {
  const resp = await rest.put(getApiUrl(`/core/roles/${roleId}`), roleData);
  const data = dataParser(
    () => zRole.parse(resp.data),
    "updated role response",
  );
  return data;
};

// Создание роли
export const createRole = async (roleData: ZRoleSaveData): Promise<ZRole> => {
  const resp = await rest.post(getApiUrl("/core/roles"), roleData);
  const data = dataParser(
    () => zRole.parse(resp.data),
    "created role response",
  );
  return data;
};

export const deleteRole = async (roleId: ZId) =>
  rest.delete(getApiUrl(`/core/roles/${roleId}`));
